import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.css']
})
export class ButtonComponent implements OnInit {

  @Input()
  title: string;

  @Input()
  buttonCssClass: string;

  @Input()
  iconCssClass: string;

  @Input()
  disabled = false;

  @Input()
  isLeftStyle: boolean;

  @Input()
  fullSize: boolean;

  @Output() clickEvent: EventEmitter<any> = new EventEmitter<any>();

  constructor() { }

  ngOnInit() {
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  get cssClass() {

    let result = this.buttonCssClass && this.buttonCssClass !== '' ? this.buttonCssClass : this.defaultCssClass;

    if (this.disabled) {
      result += ' disabled';
    }

    return result;
  }

  get defaultCssClass(): string {
    let result = this.isLeftStyle ? 'button button-left button-white' : 'button button-right button-black';
    if (!this.fullSize) {
      result += this.isLeftStyle ? ' float-left' : ' float-right';
    }
    return result;
  }

  click() {
    this.clickEvent.emit(this);
  }
}
